define("shared/components/shared/stop-the-world-modal", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.isVisible}}
    <Shared::Modal @closable={{false}} as |modal|>
  
      <modal.card @portrait={{true}}>
        {{#if (and this.isPastDue this.isNotAccountOwner)}}
          <modal.card-header class="u--p__b__sm">
            <h2 class="o--modalHeader__title">{{t "account.past_due_modal.non_admin.title"}} </h2>
          </modal.card-header>
          <modal.card-body class="u--p__t__0">
            <section data-test-id="non-owner-past-due-modal">
              <div class="u--m__t__0">
                {{html-safe (t "account.past_due_modal.non_admin.description" email=this.accountOwnerEmail)}}
              </div>
            </section>
          </modal.card-body>
        {{else if this.isPastDue}}
          <modal.card-header @title={{t "account.past_due_modal.title"}} />
          <modal.card-body data-test-id="past-due-modal">
            <p>{{t "account.past_due_modal.description" cardNumber=this.cardNumber}}</p>
            <p>{{t "account.past_due_modal.description_downgrade_warning"}}</p>
          </modal.card-body>
          <modal.card-footer>
            <Shared::Ui::Button
              @onClick={{this.redirectToPaymentMethod}}
              class="o--btn o--btn--primary u--float--right"
              {{track "past-due-modal-clicked-update-payment" "click" location="past due modal"}}
            >
              {{t "account.subscription.billing.update_card.title"}}
            </Shared::Ui::Button>
          </modal.card-footer>
        {{else}}
          <modal.card-header @title={{t "account.stop_the_world.title" planName=this.planName}} />
  
          <modal.card-body>
  
            {{#if this.currentAccount.shouldWarnOfPlanOverages}}
              <p>{{t "account.stop_the_world.overages.message"}}</p>
              <ul>
                {{#if this.hasLinkinbioPagesOverage}}
                  <li>{{t "account.stop_the_world.overages.linkinbio_pages" count=this.linkinbioPagesOverage}}</li>
                {{/if}}
                {{#if this.currentAccount.hasGroupsOverage}}
                  <li>{{t "account.stop_the_world.overages.groups" count=this.currentAccount.groupsOverage}}</li>
                {{/if}}
  
                {{#if this.currentAccount.hasUsersOverage}}
                  <li>{{t "account.stop_the_world.overages.users" count=this.currentAccount.usersOverage}}</li>
                {{/if}}
  
                {{#if this.currentAccount.hasSocialProfileOverage}}
                  <li>
                    {{t
                      "account.stop_the_world.overages.social_profiles"
                      count=this.currentAccount.socialProfilesOverage
                    }}
                  </li>
                {{/if}}
              </ul>
              {{#if this.isNotAccountOwner}}
                <p>{{t "account.stop_the_world.non_admin" email=this.accountOwnerEmail}}</p>
              {{/if}}
            {{else}}
              <p>{{t "account.stop_the_world.generic_message"}}</p>
            {{/if}}
          </modal.card-body>
          <modal.card-footer>
            {{#unless this.isPastDue}}
              {{! @glint-expect-error: LinkToExternal is not a glint component }}
              <LinkToExternal @route="plans" class="o--btn o--btn--outline" data-test-link-external="plans">
                {{t "account.downgrade.go_to_plans"}}
              </LinkToExternal>
            {{/unless}}
            <LinkTo
              @route={{@routeToDowngrade}}
              class="o--btn o--btn--primary u--float--right"
              data-test-link={{@routeToDowngrade}}
            >
              {{t "shared_words.continue"}}
            </LinkTo>
          </modal.card-footer>
        {{/if}}
  
      </modal.card>
    </Shared::Modal>
  
  {{/if}}
  */
  {
    "id": "5oV5E5o/",
    "block": "[[[41,[30,0,[\"isVisible\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@closable\"],[false]],[[\"default\"],[[[[1,\"\\n\\n    \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n\"],[41,[28,[37,2],[[30,0,[\"isPastDue\"]],[30,0,[\"isNotAccountOwner\"]]],null],[[[1,\"        \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b__sm\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,[28,[35,3],[\"account.past_due_modal.non_admin.title\"],null]],[1,\" \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,\"section\"],[14,\"data-test-id\",\"non-owner-past-due-modal\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"u--m__t__0\"],[12],[1,\"\\n              \"],[1,[28,[35,4],[[28,[37,3],[\"account.past_due_modal.non_admin.description\"],[[\"email\"],[[30,0,[\"accountOwnerEmail\"]]]]]],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isPastDue\"]],[[[1,\"        \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,3],[\"account.past_due_modal.title\"],null]]],null],[1,\"\\n        \"],[8,[30,1,[\"card-body\"]],[[24,\"data-test-id\",\"past-due-modal\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,2],[12],[1,[28,[35,3],[\"account.past_due_modal.description\"],[[\"cardNumber\"],[[30,0,[\"cardNumber\"]]]]]],[13],[1,\"\\n          \"],[10,2],[12],[1,[28,[35,3],[\"account.past_due_modal.description_downgrade_warning\"],null]],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[39,5],[[24,0,\"o--btn o--btn--primary u--float--right\"],[4,[38,6],[\"past-due-modal-clicked-update-payment\",\"click\"],[[\"location\"],[\"past due modal\"]]]],[[\"@onClick\"],[[30,0,[\"redirectToPaymentMethod\"]]]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,3],[\"account.subscription.billing.update_card.title\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,3],[\"account.stop_the_world.title\"],[[\"planName\"],[[30,0,[\"planName\"]]]]]]],null],[1,\"\\n\\n        \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n\\n\"],[41,[30,0,[\"currentAccount\",\"shouldWarnOfPlanOverages\"]],[[[1,\"            \"],[10,2],[12],[1,[28,[35,3],[\"account.stop_the_world.overages.message\"],null]],[13],[1,\"\\n            \"],[10,\"ul\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasLinkinbioPagesOverage\"]],[[[1,\"                \"],[10,\"li\"],[12],[1,[28,[35,3],[\"account.stop_the_world.overages.linkinbio_pages\"],[[\"count\"],[[30,0,[\"linkinbioPagesOverage\"]]]]]],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"currentAccount\",\"hasGroupsOverage\"]],[[[1,\"                \"],[10,\"li\"],[12],[1,[28,[35,3],[\"account.stop_the_world.overages.groups\"],[[\"count\"],[[30,0,[\"currentAccount\",\"groupsOverage\"]]]]]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"currentAccount\",\"hasUsersOverage\"]],[[[1,\"                \"],[10,\"li\"],[12],[1,[28,[35,3],[\"account.stop_the_world.overages.users\"],[[\"count\"],[[30,0,[\"currentAccount\",\"usersOverage\"]]]]]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"currentAccount\",\"hasSocialProfileOverage\"]],[[[1,\"                \"],[10,\"li\"],[12],[1,\"\\n                  \"],[1,[28,[35,3],[\"account.stop_the_world.overages.social_profiles\"],[[\"count\"],[[30,0,[\"currentAccount\",\"socialProfilesOverage\"]]]]]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n\"],[41,[30,0,[\"isNotAccountOwner\"]],[[[1,\"              \"],[10,2],[12],[1,[28,[35,3],[\"account.stop_the_world.non_admin\"],[[\"email\"],[[30,0,[\"accountOwnerEmail\"]]]]]],[13],[1,\"\\n\"]],[]],null]],[]],[[[1,\"            \"],[10,2],[12],[1,[28,[35,3],[\"account.stop_the_world.generic_message\"],null]],[13],[1,\"\\n\"]],[]]],[1,\"        \"]],[]]]]],[1,\"\\n        \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[51,[30,0,[\"isPastDue\"]]],[[[1,\"            \"],[8,[39,8],[[24,0,\"o--btn o--btn--outline\"],[24,\"data-test-link-external\",\"plans\"]],[[\"@route\"],[\"plans\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,3],[\"account.downgrade.go_to_plans\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"          \"],[8,[39,9],[[24,0,\"o--btn o--btn--primary u--float--right\"],[16,\"data-test-link\",[30,2]]],[[\"@route\"],[[30,2]]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,3],[\"shared_words.continue\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[]]]],[]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\\n\"]],[]],null]],[\"modal\",\"@routeToDowngrade\"],false,[\"if\",\"shared/modal\",\"and\",\"t\",\"html-safe\",\"shared/ui/button\",\"track\",\"unless\",\"link-to-external\",\"link-to\"]]",
    "moduleName": "shared/components/shared/stop-the-world-modal.hbs",
    "isStrictMode": false
  });
  let StopTheWorldModalComponent = _exports.default = (_class = class StopTheWorldModalComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "payment", _descriptor2, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _initializerDefineProperty(this, "creditCard", _descriptor5, this);
      _initializerDefineProperty(this, "showSuccessModal", _descriptor6, this);
      _initializerDefineProperty(this, "isChargingInvoice", _descriptor7, this);
      _defineProperty(this, "loadCard", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.creditCard = yield this.payment.retrieveCard.perform();
        }
      }), null, "loadCard", null));
      if (this.isPastDue) {
        this.loadCard.perform();
      }
    }
    get accountOwnerEmail() {
      return this.currentAccount.owner.get('email');
    }
    get cardNumber() {
      return this.creditCard?.card?.last4;
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get hasLinkinbioPagesOverage() {
      return this.currentAccount.hasOverageLinkinbioPages;
    }
    get isNotAccountOwner() {
      return !this.auth.currentUserModel?.isAccountOwner;
    }
    get linkinbioPagesOverage() {
      return this.currentAccount.linkinbioPagesOverage;
    }
    get planName() {
      return this.subscriptions.subscriptionPlan?.displayName;
    }
    get showLinkinbioWarning() {
      return this.currentAccount.linkinbioEnabled;
    }
    get isPastDue() {
      return this.subscriptions.isPastDue;
    }
    get isVisible() {
      return this.currentAccount.stopTheWorldOrPastDue;
    }

    /**
     * Note: using router.transitionTo in order to avoid checking for the need to use
     * LinkTo or LinkToExternal in the template.
     */
    redirectToPaymentMethod() {
      this.router.transitionTo('account.subscription.billing.payment_method');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "creditCard", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showSuccessModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isChargingInvoice", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "redirectToPaymentMethod", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "redirectToPaymentMethod"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, StopTheWorldModalComponent);
});